import { MatomoProvider as DatapuntMatomoProvider } from '@datapunt/matomo-tracker-react';
import { createElement, ReactNode } from 'react';

import { matomoInstance } from './matomoInstance';

type Props = {
	children: ReactNode;
};

export const MatomoProvider = ({ children }: Props) =>
	createElement(DatapuntMatomoProvider, { value: matomoInstance }, children);
